export default "__VITE_ASSET__272b7f43__"